export default __webpack_public_path__ + "media/images/temporary/awards-8f31fabb6136a857a9530ef7806c6dfe.jpg";